<p style="margin-top: 0.5rem">
  Users must upload both front and back photos of their indentification
</p>

<clr-toggle-wrapper>
  <input type="checkbox" clrToggle name="enabled" [formControl]="formControl" />
  <label>{{ "common.enabled" | translate }}</label>
</clr-toggle-wrapper>
